import React, { useEffect, useState } from 'react'
import { message } from 'antd'

export default function useFetchObject(
  readFunction,
  isFetching = false,
  dependencyArray = [],
  dontFetch = false,
  defaultObject = {},
  isResponse = false,
  afterFetchFunc = () => {}
) {
  const [object, setObject] = useState(defaultObject)
  const [fetching, setFetching] = useState(isFetching)

  async function fetch() {
    if (!dontFetch) {
      setFetching(true)
      try {
        let object
        object = await readFunction()
        if (isResponse === true) object = await object.json()
        setObject(object)
        afterFetchFunc()
      } catch (e) {
        console.error(e)
        message.error(e.errorMessage || 'error')
      }
      setFetching(false)
    }
  }

  useEffect(() => {
    if (!dontFetch) fetch()
    return () => {}
  }, dependencyArray)
  return { object, fetching, fetch, setObject }
}
